module.exports = __webpack_public_path__ + "static/media/v1.0.8c235960.pdf";